import React, { useState } from "react";
import "./checkbox.css";

const CheckBox = ({ value, onClick, id }) => {
  const [check, setCheck] = useState(value ? value : false);

  const handleCheck = () => {
    if (onClick) onClick({ status: !check, id: id });
    setCheck(!check);
  };

  return (
    <>
      <input type="checkbox" value={check} onClick={handleCheck} id={id} />
      <label htmlFor={id} value={check}></label>
    </>
  );
};
export default CheckBox;
